var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKebab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7C12.1 7 13 6.1 13 5C13 3.9 12.1 3 11 3C9.9 3 9 3.9 9 5C9 6.1 9.9 7 11 7ZM11 9C9.9 9 9 9.9 9 11C9 12.1 9.9 13 11 13C12.1 13 13 12.1 13 11C13 9.9 12.1 9 11 9ZM11 15C9.9 15 9 15.9 9 17C9 18.1 9.9 19 11 19C12.1 19 13 18.1 13 17C13 15.9 12.1 15 11 15Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKebab);
export default __webpack_public_path__ + "static/media/iconKebab.bc6ad38b7f724000acb6a91cd2064624.svg";
export { ForwardRef as ReactComponent };